import React from 'react';

const UniBreak = (props) => {
  return (
    <br />
  );
};

export default UniBreak;